import { useEffect, useRef, useState } from 'react';
import { getSocket, subscribeSocket } from '../services/socketService';

export const useSocketEvent = (event, handler) => {
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    const [socket, setSocket] = useState(() => getSocket());

    useEffect(() => {
        setSocket(getSocket());
        return subscribeSocket((nextSocket) => setSocket(nextSocket));
    }, []);

    useEffect(() => {
        if (!socket) return undefined;
        const listener = (payload) => handlerRef.current(payload);
        socket.on(event, listener);
        return () => socket.off(event, listener);
    }, [event, socket]);
};

export default useSocketEvent;
